import React from 'react'

export const PrivacyPolicy = () => {
  return (
    <div className="p-20 w-100 fs-5">
      <h1 className="h1 mb-10">Privacy Policy</h1>

      <p>
        At Talking Iris, your privacy—and the privacy of your loved one—is our highest priority. Our eye-tracking communication system is built to run fully offline, so everything stays on your device and under your control.
      </p>

      <h2 className="h2 mt-10 mb-4">Designed to Be Private</h2>
      <p>
        Talking Iris does not require an internet connection. All customizations, preferences, and calibration data are stored securely on the device itself. We do not use cloud servers or remote backups—your data never leaves your hands.
      </p>

      <h2 className="h2 mt-10 mb-4">No Tracking, No Sharing</h2>
      <ul>
        <li>We do not collect personal information such as names, photos, gaze history, or biometric data.</li>
        <li>We do not transmit any data to third parties or analytics services.</li>
        <li>No login or account is required to use Talking Iris.</li>
      </ul>

      <h2 className="h2 mt-10 mb-4">You’re in Control</h2>
      <p>
        All data remains stored locally on your device. If you delete the app or reset the device, all information is permanently erased. There are no backups or remote copies.
      </p>

      <h2 className="h2 mt-10 mb-4">Built for Families, Not Data</h2>
      <p>
        Talking Iris was created by families, for families—especially those supporting non-verbal or neurodivergent loved ones. We believe assistive technology should empower, not compromise privacy. That’s our promise to you.
      </p>
    </div>
  );
};
